import { render, staticRenderFns } from "./FirstDayReport.vue?vue&type=template&id=6f97c69f"
import script from "./FirstDayReport.vue?vue&type=script&lang=js"
export * from "./FirstDayReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports